import React, { useEffect, useState } from 'react';
import { Grid2, Typography, List, ListItemText, ListItemIcon, Dialog, DialogTitle, DialogContent, DialogActions, Button, TextField, Divider, ListItem, Collapse } from '@mui/material';
import NotesIcon from '@mui/icons-material/Notes';
import { supabase } from '../components/supabaseClient.tsx';
import ListItemButton from "@mui/material/ListItemButton";
import Checkbox from '@mui/material/Checkbox';
import IconButton from '@mui/material/IconButton';
import PushPinIcon from '@mui/icons-material/PushPin';
import DeleteIcon from '@mui/icons-material/Delete';
import PlaylistAddIcon from '@mui/icons-material/PlaylistAdd';
import EditNoteIcon from '@mui/icons-material/EditNote';
import UndoIcon from '@mui/icons-material/Undo';
import Alert from "@mui/material/Alert";
import CloseIcon from '@mui/icons-material/Close';
import AlertTitle from '@mui/material/AlertTitle';

interface Notiz {
    id: number;
    created_at: string;
    Titel: string;
    Description: string;
    change_date: string;
    User: string;
    is_pinned: boolean;
}

export default function Notes() {
    const [notizen, setNotizen] = useState<Notiz[]>([]);
    const [selectedIndex, setSelectedIndex] = useState<number | null>(null);
    const [isDialogOpen, setIsDialogOpen] = useState(false);
    const [selectedNotiz, setSelectedNotiz] = useState<Notiz | null>(null);
    const [isNewNoteDialogOpen, setIsNewNoteDialogOpen] = useState(false);
    const [newNoteTitle, setNewNoteTitle] = useState('');
    const [newNoteDescription, setNewNoteDescription] = useState('');
    const [checked, setChecked] = React.useState([]);
    const [isEditDialogOpen, setIsEditDialogOpen] = useState(false);
    const [editNote, setEditNote] = useState<Notiz | null>(null);
    const [editNoteTitle, setEditNoteTitle] = useState('');
    const [editNoteDescription, setEditNoteDescription] = useState('');
    const [alert, setAlert] = useState<JSX.Element | null>(null);
    const [open, setOpen] = React.useState(true);

    const handleToggle = (notiz: Notiz) => () => {
        const currentIndex = checked.indexOf(notiz.id);
        const newChecked = [...checked];

        if (currentIndex === -1) {
            newChecked.push(notiz.id);
        } else {
            newChecked.splice(currentIndex, 1);
        }

        setChecked(newChecked);
    };

    const handleListItemClick = (
        event: React.MouseEvent<HTMLDivElement, MouseEvent>,
        index: number,
        notiz: Notiz
    ) => {
        setSelectedIndex(index);
        setSelectedNotiz(notiz);
        setIsDialogOpen(true);
    };

    const handleCloseDialog = () => {
        setIsDialogOpen(false);
        setSelectedNotiz(null);
        setSelectedIndex(null);
    };

    const handleNewNote = () => {
        setIsNewNoteDialogOpen(true);
    };

    const handleCloseNewNoteDialog = () => {
        setIsNewNoteDialogOpen(false);
        setNewNoteTitle('');
        setNewNoteDescription('');
    };

    const handleOpenEditDialog = (notiz: Notiz) => {
        setEditNoteTitle(notiz.Titel);
        setEditNoteDescription(notiz.Description);
        setEditNote(notiz);
        setIsEditDialogOpen(true);
    };

    const handleEditNote = () => {
        if (checked.length === 1) {
            const noteToEdit = notizen.find(note => note.id === checked[0]);
            if (noteToEdit) {
                handleOpenEditDialog(noteToEdit);
            }
        }
    };

    const handleSaveEditNote = async () => {
        if (editNote) {
            const currentDate = new Date().toISOString();
            try {
                const { error } = await supabase
                    .from('Notizen')
                    .update({
                        Titel: editNoteTitle,
                        Description: editNoteDescription,
                        change_date: currentDate,
                    })
                    .eq('id', editNote.id);

                if (error) {
                    throw error;
                }

                setNotizen(notizen.map(note => note.id === editNote.id ? { ...note, Titel: editNoteTitle, Description: editNoteDescription, change_date: currentDate } : note));
                setIsEditDialogOpen(false);
                setEditNoteTitle('');
                setEditNoteDescription('');
                setEditNote(null);
                setAlert(
                    <Collapse in={open} style={{ position: 'absolute', top: '50px', right: '20px', zIndex: 1000 }}>
                        <Alert
                            action={
                                <IconButton
                                    aria-label="close"
                                    color="inherit"
                                    size="small"
                                    onClick={() => {
                                        setOpen(false);
                                        setAlert(null);
                                    }}
                                >
                                    <CloseIcon fontSize="inherit" />
                                </IconButton>
                            }
                            sx={{ mb: 2 }}
                            severity={"success"}
                        >
                            <AlertTitle>Success</AlertTitle>
                            Note edited successfully!
                        </Alert>
                    </Collapse>
                );
                setTimeout(() => {
                    setOpen(false);
                }, 3000);
            } catch (error) {
                setAlert(
                    <Collapse in={open} style={{ position: 'absolute', top: '50px', right: '20px', zIndex: 1000 }}>
                        <Alert
                            action={
                                <IconButton
                                    aria-label="close"
                                    color="inherit"
                                    size="small"
                                    onClick={() => {
                                        setOpen(false);
                                        setAlert(null);
                                    }}
                                >
                                    <CloseIcon fontSize="inherit" />
                                </IconButton>
                            }
                            sx={{ mb: 2 }}
                            severity={"error"}
                        >
                            <AlertTitle>Error</AlertTitle>
                            Failed to edit note!
                        </Alert>
                    </Collapse>
                );
                setTimeout(() => {
                    setOpen(false);
                }, 3000);
            }
        }
    };

    const handleSaveNewNote = async () => {
        const currentDate = new Date().toISOString();
        try {
            console.log(newNoteTitle, newNoteDescription, currentDate);
            const { data, error } = await supabase
                .from('Notizen')
                .insert([{ Titel: newNoteTitle, Description: newNoteDescription, change_date: currentDate, is_pinned: false }]);

            handleCloseNewNoteDialog();
            if (error) {
                throw error;
            }

            setNotizen([...notizen, ...data]);
            setAlert(
                <Collapse in={open} style={{ position: 'absolute', top: '50px', right: '20px', zIndex: 1000 }}>
                    <Alert
                        action={
                            <IconButton
                                aria-label="close"
                                color="inherit"
                                size="small"
                                onClick={() => {
                                    setOpen(false);
                                    setAlert(null);
                                }}
                            >
                                <CloseIcon fontSize="inherit" />
                            </IconButton>
                        }
                        sx={{ mb: 2 }}
                        severity={"success"}
                    >
                        <AlertTitle>Success</AlertTitle>
                        Note created successfully!
                    </Alert>
                </Collapse>
            );
            setTimeout(() => {
                setOpen(false);
            }, 3000);
        } catch (error) {
            setAlert(
                <Collapse in={open} style={{ position: 'absolute', top: '50px', right: '20px', zIndex: 1000 }}>
                    <Alert
                        action={
                            <IconButton
                                aria-label="close"
                                color="inherit"
                                size="small"
                                onClick={() => {
                                    setOpen(false);
                                    setAlert(null);
                                }}
                            >
                                <CloseIcon fontSize="inherit" />
                            </IconButton>
                        }
                        sx={{ mb: 2 }}
                        severity={"error"}
                    >
                        <AlertTitle>Error</AlertTitle>
                        Failed to create note!
                    </Alert>
                </Collapse>
            );
            setTimeout(() => {
                setOpen(false);
            }, 3000);
        }
    };

    const loadNotizen = async () => {
        try {
            const { data, error } = await supabase
                .from('Notizen')
                .select('*');

            if (error) {
                console.error(error);
            }

            setNotizen(data || []);
        } catch (error) {
            console.error('Error loading notes:', error);
        }
    };

    const handleDeleteNote = async () => {
        if (checked.length > 0) {
            try {
                const { error } = await supabase
                    .from('Notizen')
                    .delete()
                    .in('id', checked);

                if (error) {
                    throw error;
                }

                setNotizen(notizen.filter(note => !checked.includes(note.id)));
                setChecked([]);
                setAlert(
                    <Collapse in={open} style={{ position: 'absolute', top: '50px', right: '20px', zIndex: 1000 }}>
                        <Alert
                            action={
                                <IconButton
                                    aria-label="close"
                                    color="inherit"
                                    size="small"
                                    onClick={() => {
                                        setOpen(false);
                                        setAlert(null);
                                    }}
                                >
                                    <CloseIcon fontSize="inherit" />
                                </IconButton>
                            }
                            sx={{ mb: 2 }}
                            severity={"success"}
                        >
                            <AlertTitle>Success</AlertTitle>
                            Note deleted successfully!
                        </Alert>
                    </Collapse>
                );
                setTimeout(() => {
                    setOpen(false);
                }, 3000);
            } catch (error) {
                setAlert(
                    <Collapse in={open} style={{ position: 'absolute', top: '50px', right: '20px', zIndex: 1000 }}>
                        <Alert
                            action={
                                <IconButton
                                    aria-label="close"
                                    color="inherit"
                                    size="small"
                                    onClick={() => {
                                        setOpen(false);
                                        setAlert(null);
                                    }}
                                >
                                    <CloseIcon fontSize="inherit" />
                                </IconButton>
                            }
                            sx={{ mb: 2 }}
                            severity={"error"}
                        >
                            <AlertTitle>Error</AlertTitle>
                            Failed to delete note!
                        </Alert>
                    </Collapse>
                );
                setTimeout(() => {
                    setOpen(false);
                }, 3000);
            }
        }
    };

    const handlePinnNote = async () => {
        if (checked.length > 0) {
            try {
                const { error } = await supabase
                    .from('Notizen')
                    .update({ is_pinned: true })
                    .in('id', checked);

                if (error) {
                    throw error;
                }

                setNotizen(notizen.map(note => checked.includes(note.id) ? { ...note, is_pinned: true } : note));
                setChecked([]);
                setAlert(
                    <Collapse in={open} style={{ position: 'absolute', top: '50px', right: '20px', zIndex: 1000 }}>
                        <Alert
                            action={
                                <IconButton
                                    aria-label="close"
                                    color="inherit"
                                    size="small"
                                    onClick={() => {
                                        setOpen(false);
                                        setAlert(null);
                                    }}
                                >
                                    <CloseIcon fontSize="inherit" />
                                </IconButton>
                            }
                            sx={{ mb: 2 }}
                            severity={"success"}
                        >
                            <AlertTitle>Success</AlertTitle>
                            Note pinned successfully!
                        </Alert>
                    </Collapse>
                );
                setTimeout(() => {
                    setOpen(false);
                }, 3000);
            } catch (error) {
                setAlert(
                    <Collapse in={open} style={{ position: 'absolute', top: '50px', right: '20px', zIndex: 1000 }}>
                        <Alert
                            action={
                                <IconButton
                                    aria-label="close"
                                    color="inherit"
                                    size="small"
                                    onClick={() => {
                                        setOpen(false);
                                        setAlert(null);
                                    }}
                                >
                                    <CloseIcon fontSize="inherit" />
                                </IconButton>
                            }
                            sx={{ mb: 2 }}
                            severity={"error"}
                        >
                            <AlertTitle>Error</AlertTitle>
                            Failed to pin note!
                        </Alert>
                    </Collapse>
                );
                setTimeout(() => {
                    setOpen(false);
                }, 3000);
            }
        }
    };

    const handleUnpinNote = async () => {
        if (checked.length > 0) {
            try {
                const { error } = await supabase
                    .from('Notizen')
                    .update({ is_pinned: false })
                    .in('id', checked);

                if (error) {
                    throw error;
                }

                setNotizen(notizen.map(note => checked.includes(note.id) ? { ...note, is_pinned: false } : note));
                setChecked([]);
                setAlert(
                    <Collapse in={open} style={{ position: 'absolute', top: '50px', right: '20px', zIndex: 1000 }}>
                        <Alert
                            action={
                                <IconButton
                                    aria-label="close"
                                    color="inherit"
                                    size="small"
                                    onClick={() => {
                                        setOpen(false);
                                        setAlert(null);
                                    }}
                                >
                                    <CloseIcon fontSize="inherit" />
                                </IconButton>
                            }
                            sx={{ mb: 2 }}
                            severity={"success"}
                        >
                            <AlertTitle>Success</AlertTitle>
                            Note unpinned successfully!
                        </Alert>
                    </Collapse>
                );
                setTimeout(() => {
                    setOpen(false);
                }, 3000);
            } catch (error) {
                setAlert(
                    <Collapse in={open} style={{ position: 'absolute', top: '50px', right: '20px', zIndex: 1000 }}>
                        <Alert
                            action={
                                <IconButton
                                    aria-label="close"
                                    color="inherit"
                                    size="small"
                                    onClick={() => {
                                        setOpen(false);
                                        setAlert(null);
                                    }}
                                >
                                    <CloseIcon fontSize="inherit" />
                                </IconButton>
                            }
                            sx={{ mb: 2 }}
                            severity={"error"}
                        >
                            <AlertTitle>Error</AlertTitle>
                            Failed to unpin note!
                        </Alert>
                    </Collapse>
                );
                setTimeout(() => {
                    setOpen(false);
                }, 3000);
            }
        }
    };

    useEffect(() => {
        loadNotizen();
    }, []);

    return (
        <div style={{width: 'auto', height: 'auto'}}>
            <div style={{
                position: 'absolute',
                top: '20px',
                right: '20px',
                zIndex: 1000,
            }}>
                {alert}
            </div>
            <Grid2 container spacing={2} style={{
                display: 'flex',
                justifyContent: 'flex-start',
                alignItems: 'flex-start',
                flexDirection: 'row'
            }}>
                <Grid2 style={{width:'fit-content'}}>
                    <List component="nav" sx={{width: '600px', bgcolor: 'background.paper'}}>
                    {notizen.length === 0 ? (
                        <Typography variant="h6" style={{ padding: '20px' }}>
                            There is no Note
                        </Typography>
                    ) : (
                        notizen.map((notiz, index) => (
                            <ListItem
                                key={notiz.id}
                                secondaryAction={
                                    <IconButton edge="end" aria-label="comments">
                                        {notiz.is_pinned ? <PushPinIcon /> : <NotesIcon />}
                                    </IconButton>
                                }
                                disablePadding
                            >
                                <React.Fragment key={notiz.id}>
                                    <ListItemButton
                                        key={notiz.id}
                                        selected={selectedIndex === index}
                                        onClick={(event) => handleListItemClick(event, index, notiz)}
                                    >
                                        <ListItemIcon>
                                            <Checkbox
                                                edge="start"
                                                checked={checked.includes(notiz.id)}
                                                tabIndex={-1}
                                                disableRipple
                                                onClick={(event) => {
                                                    event.stopPropagation();
                                                    handleToggle(notiz)();
                                                }}
                                            />
                                        </ListItemIcon>
                                        <ListItemText
                                            primary={`${notiz.Titel} - ${notiz.Description.length > 30 ? notiz.Description.substring(0, 30) + '...' : notiz.Description}`}/>
                                    </ListItemButton>
                                    {index < notizen.length - 1 && <Divider/>}
                                </React.Fragment>
                            </ListItem>
                            ))
                    )}
                    </List>
                    {selectedNotiz && (
                        <Dialog open={isDialogOpen} onClose={handleCloseDialog} maxWidth="sm" fullWidth>
                            <DialogTitle>{selectedNotiz.Titel}</DialogTitle>
                            <DialogContent>
                                <Typography variant="body1" gutterBottom>
                                    {selectedNotiz.Description}
                                </Typography>
                                <Typography variant="body2" color="textSecondary">
                                    Creation date: {new Date(selectedNotiz.created_at).toLocaleString()}
                                </Typography>
                                <Typography variant="body2" color="textSecondary">
                                    Last change: {new Date(selectedNotiz.change_date).toLocaleString()}
                                </Typography>
                            </DialogContent>
                            <DialogActions>
                                <Button onClick={handleCloseDialog} color="primary">
                                    Close
                                </Button>
                            </DialogActions>
                        </Dialog>
                    )}
                </Grid2>
                <Grid2 style={{width: '30%', height: 'auto', paddingLeft: '8px'}}>
                    <Button
                        variant="contained"
                        endIcon={<PlaylistAddIcon/>}
                        onClick={handleNewNote}
                        style={{width: '100%', height: '50px'}}
                    >
                        New Note
                    </Button>
                    <Button
                        variant="contained"
                        endIcon={<DeleteIcon/>}
                        onClick={handleDeleteNote}
                        style={{width: '100%', height: '50px', marginTop: '10px'}}
                        disabled={checked.length === 0}
                    >
                        Delete Note/s
                    </Button>
                    <Button
                        variant="contained"
                        endIcon={<EditNoteIcon/>}
                        onClick={handleEditNote}
                        style={{width: '100%', height: '50px', marginTop: '10px'}}
                        disabled={checked.length === 0 || checked.length > 1}
                    >
                        Edit Note
                    </Button>
                    <Button
                        variant="contained"
                        endIcon={<PushPinIcon/>}
                        onClick={handlePinnNote}
                        style={{width: '48%', height: '50px', marginTop: '10px', textSizeAdjust: 'auto'}}
                        disabled={checked.length === 0}
                    >
                        Pin Note/s
                    </Button>
                    <Button
                        variant="contained"
                        endIcon={<UndoIcon/>}
                        onClick={handleUnpinNote}
                        style={{width: '49%', height: '50px', marginTop: '10px', marginLeft:'10px', fontSize: '14px'}}
                        disabled={checked.length === 0}
                    >
                        Unpin Note/s
                    </Button>
                </Grid2>
                <Dialog open={isNewNoteDialogOpen} onClose={handleCloseNewNoteDialog} maxWidth="sm" fullWidth>
                    <DialogTitle>New Note</DialogTitle>
                    <DialogContent>
                        <TextField
                            label="Title"
                            fullWidth
                            value={newNoteTitle}
                            onChange={(e) => setNewNoteTitle(e.target.value)}
                            margin="normal"
                        />
                        <TextField
                            label="Description"
                            fullWidth
                            multiline
                            rows={4}
                            value={newNoteDescription}
                            onChange={(e) => setNewNoteDescription(e.target.value)}
                            margin="normal"
                        />
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={handleCloseNewNoteDialog} color="primary">
                            Cancel
                        </Button>
                        <Button onClick={handleSaveNewNote} color="primary">
                            Save
                        </Button>
                    </DialogActions>
                </Dialog>
                <Dialog open={isEditDialogOpen} onClose={() => setIsEditDialogOpen(false)} maxWidth="sm" fullWidth>
                    <DialogTitle>Edit Note</DialogTitle>
                    <DialogContent>
                        <TextField
                            label="Title"
                            fullWidth
                            value={editNoteTitle}
                            onChange={(e) => setEditNoteTitle(e.target.value)}
                            margin="normal"
                        />
                        <TextField
                            label="Description"
                            fullWidth
                            multiline
                            rows={4}
                            value={editNoteDescription}
                            onChange={(e) => setEditNoteDescription(e.target.value)}
                            margin="normal"
                        />
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={() => setIsEditDialogOpen(false)} color="primary">
                            Cancel
                        </Button>
                        <Button onClick={handleSaveEditNote} color="primary">
                            Save
                        </Button>
                    </DialogActions>
                </Dialog>
            </Grid2>
        </div>
            );
            }